import React from 'react';
import Text from '@/components/ui/Text';
import cn from '@/utils/cn';

interface HeaderNumberBoxProps {
  number: number;
}

const HeaderNumberBox = ({ number }: HeaderNumberBoxProps) => (
  <div className={cn('tw-inline-block tw-w-9 tw-h-9 tw-rounded-md tw-mr-2 tw-border tw-border-grey tw-border-solid',
    'tw-text-center')
  }
  >
    <Text
      className={cn('!tw-font-bold [.k5_&]:!tw-font-medium tw-w-full tw-h-full tw-align-middle tw-leading-9',
        'tw-rounded-md tw-bg-white')}
      tag="span"
      variant="heading2"
    >
      {number}
    </Text>
  </div>
);

export default HeaderNumberBox;
